import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../service/api/api.service';
import { MatDialog } from '@angular/material/dialog';
import { EvaluationComponent } from '../evaluation/evaluation.component';
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SidebarComponent, NavbarComponent,RouterModule,CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  private intervalId: any; // Pour stocker l'ID de l'intervalle afin de le nettoyer
  private dialogueOuvert: boolean = false; // Suivre l'état de la boîte de dialogue
  private evaluationCheckedThisInterval: boolean = false; // Suivre si une vérification a été faite dans cet intervalle

  constructor(public api: ApiService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.api.get_utilisateur_data();
    // this.checkEvaluationDisplay();
  }
  //----------------------------------- Évaluations ----------------------------------------------

  checkEvaluationDisplay() {
    const premiereUtilisation = localStorage.getItem('firstUseDate');
    const dixMinutesEnMs = 10 * 60 * 1000; // Corrigé à 10 minutes (600 000 ms)

    // Définir la date de première utilisation si elle n'existe pas
    if (!premiereUtilisation) {
      localStorage.setItem('firstUseDate', Date.now().toString());
    } else {
      const tempsEcoule = Date.now() - parseInt(premiereUtilisation, 10);
      if (isNaN(tempsEcoule)) {
        console.warn(
          'Date de première utilisation invalide, réinitialisation...'
        );
        localStorage.setItem('firstUseDate', Date.now().toString());
      } else if (
        tempsEcoule >= dixMinutesEnMs &&
        !localStorage.getItem('evaluationSubmitted') &&
        !this.dialogueOuvert &&
        !this.evaluationCheckedThisInterval
      ) {
        this.ouvrirDialogueEvaluation();
        this.evaluationCheckedThisInterval = true; // Marquer cette vérification comme effectuée
      }
    }

    // Configurer une vérification récurrente
    this.intervalId = setInterval(() => {
      const utilisationActuelle = localStorage.getItem('firstUseDate');
      const ecoule = Date.now() - parseInt(utilisationActuelle || '0', 10);
      this.evaluationCheckedThisInterval = false; // Réinitialiser pour le nouvel intervalle
      if (isNaN(ecoule)) {
        console.warn(
          'Temps écoulé invalide, réinitialisation de firstUseDate...'
        );
        localStorage.setItem('firstUseDate', Date.now().toString());
      } else if (
        ecoule >= dixMinutesEnMs &&
        !localStorage.getItem('evaluationSubmitted') &&
        !this.dialogueOuvert &&
        !this.evaluationCheckedThisInterval
      ) {
        this.ouvrirDialogueEvaluation();
        this.evaluationCheckedThisInterval = true; // Marquer cette vérification comme effectuée
      }
    }, dixMinutesEnMs);
  }

  ouvrirDialogueEvaluation() {
    if (this.dialogueOuvert) return; // Empêcher l'ouverture multiple si déjà ouvert

    this.dialogueOuvert = true;
    const dialogueRef = this.dialog.open(EvaluationComponent, {
      width: '500px',
      disableClose: false,
    });

    dialogueRef.afterClosed().subscribe((resultat: boolean) => {
      this.dialogueOuvert = false; // Réinitialiser l'état de la boîte
      if (resultat === true) {
        localStorage.setItem('evaluationSubmitted', 'true');
      } else if (resultat === false) {
        localStorage.removeItem('evaluationSubmitted');
      } else {
        console.log('Boîte de dialogue fermée sans résultat clair :', resultat);
      }
    });
  }

  ngOnDestroy() {
    // Nettoyer l'intervalle pour éviter les fuites de mémoire
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
